import { gql } from "@apollo/client";

export const GET_PAYMENT_CARDS_PERSONAL = gql`
  query getPaymentCardsPersonal {
    getPaymentCardsPersonal
  }
`;

export const GET_ALL_USER_NOTIFICATIONS = gql`
  query GetAllUserNotifications($eventId: String) {
    getAllUserNotifications(eventId: $eventId)
  }
`;

export const MARK_NOTIFICATION_AS_READ = gql`
  mutation MarkNotificationAsRead($data: NotificationIdentifierInput!) {
    markNotificationAsRead(data: $data)
  }
`;

export const GET_USER_CALENDAR_INVITATIONS = gql`
  query UserCalendarInvitations($data: UserCalendarInvitationsInput!) {
    getUserCalendarInvitations(data: $data)
  }
`;

export const GET_ATTENDEE_CALENDAR_INVITATIONS = gql`
  query AttendeeCalendarInvitations($data: AttendeeCalendarInvitationsInput!) {
    getAttendeeCalendarInvitations(data: $data)
  }
`;

export const FAMILY_MEMBER_IN_USER = gql`
  query familyMemberInUser($userID: String!) {
    familyMemberInUser(data: { userID: $userID })
  }
`;

export const SWITCH_COMPANY = gql`
  mutation switchCompany($data: SwitchCompanyInput!) {
    switchCompany(data: $data)
  }
`;

export const ME = gql`
  query me {
    me
  }
`;

export const GET_CURRENT_COMPANY = gql`
  query getCurrentCompany {
    getCurrentCompany
  }
`;

export const GET_FAMILY_RELATIONSHIP_BY_ID = gql`
  query getFamilyRelationshipById($relationshipID: String!) {
    getFamilyRelationshipById(relationshipID: $relationshipID)
  }
`;

export const GET_USER_RATINGS = gql`
  query getUserRatings($eventId: String!) {
    getUserRatings(data: { eventId: $eventId })
  }
`;

export const GET_EVENT_RATINGS = gql`
  query getEventRatings($eventId: String!) {
    getEventRatings(data: { eventId: $eventId })
  }
`;
